import { useDebounceFn } from 'ahooks';
import { Checkbox, Form, Tooltip } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxInputNumber } from 'components/RevxInputNumber';
import { RevxMoney } from 'components/RevxMoney';
import { RevxSpin } from 'components/RevxSpin';
import { SiteRoleEnum } from 'domains/roleDomain';
import {
  JobCancellationParams,
  JobCancellationViewer,
  JobItem,
  JobTypeEnum,
} from 'domains/workspaceDomain';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  JOB_ADJUSTMENT_WORKSPACE_FILTER,
  QUANTITY_DEBOUNCE_MILLISECOND,
} from 'utils/constants';
import './JobCancellationSource.less';

interface IJobCancellationSource {
  data: JobCancellationViewer;
  setJobCancellations: Dispatch<
    SetStateAction<JobCancellationViewer | undefined>
  >;
  jobData?: JobItem;
  jobId?: number;
  onSuccess?: () => void;
  readOnly?: boolean;
}

const JobCancellationSource = (props: IJobCancellationSource) => {
  // const [invoiceFileList, setInvoiceFileList] = useState<UploadFile[]>([]);
  const history = useHistory();
  const {
    data,
    setJobCancellations,
    jobData,
    jobId: jobIdProp,
    onSuccess,
    readOnly,
  } = props;
  // const user = useUser();
  const urlParams = useParams<{ jobId: string }>();
  const jobId = jobIdProp || (urlParams.jobId ? +urlParams.jobId : undefined);
  const uiStatusFilter = useAppSelector(
    (state) => state.workspace.uiStatusFilter
  );
  // const cancelSources = useRef<{ source: CancelTokenSource; uid: string }[]>(
  //   []
  // );

  const dispatch = useAppDispatch();

  // const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);
  // const [uploading, setUploading] = useState<boolean>(false);

  // useEffect(() => {
  //   if (data.customerInvoiceUrl) {
  //     setInvoiceFileList([
  //       {
  //         url: `${UPLOAD_FILE_ADDRESS_PREFIX}${data.customerInvoiceUrl}`,
  //         fileName: 'Invoice File',
  //         name: 'Invoice File',
  //       } as UploadFile,
  //     ]);
  //     dispatch.app.setState({
  //       isUploading: false,
  //     });
  //   }
  //   // eslint-disable-next-line
  // }, [data]);

  // const uploadHandleRequest = async (option: any) => {
  //   setLoading(true);
  //   setUploading(true);
  //   try {
  //     // s3 upload
  //     dispatch.app.setState({
  //       isUploading: true,
  //     });
  //     const fileUrl = await dispatch.uploadFile.getPresigned([
  //       option.file.name,
  //     ]);
  //     const uploadFileUrl = fileUrl[0].path;

  //     const source = axios.CancelToken.source();
  //     cancelSources.current.push({
  //       source,
  //       uid: option?.file?.uid,
  //     });

  //     const uploadRes = await workspaceDetailService.uploadFileToWorkSpace(
  //       uploadFileUrl,
  //       option.file,
  //       {
  //         token: source.token,
  //       },
  //       (param: ProgressEvent) => {
  //         option.onProgress({
  //           percent: Math.ceil((param.loaded / option.file.size) * 99),
  //         });
  //       }
  //     );
  //     if (!uploadRes || uploadRes.status !== 200) {
  //       option.onError();
  //       dispatch.app.setState({
  //         isUploading: false,
  //       });
  //       return false;
  //     }
  //     const uploadFileUrlObject = new URL(uploadFileUrl);
  //     const fileRes = {
  //       path: uploadFileUrlObject.pathname.substr(1),
  //       fileName: option.file.name,
  //     };
  //     setInvoiceFileList([
  //       {
  //         ...option.file,
  //         url: `${UPLOAD_FILE_ADDRESS_PREFIX}${option.file.url}`,
  //         fileName: 'Invoice File',
  //         name: 'Invoice File',
  //       },
  //     ]);
  //     // const fileExtension = option.file.name.split('.').pop() || '';
  //     // if (fileExtension === 'pdf') {
  //     //   await new Promise((resolve) =>
  //     //     stepPrint(uploadFileUrlObject.pathname.substr(1), 0, resolve)
  //     //   );
  //     // }

  //     updateJobCancellationsHandle({ customerInvoiceUrl: fileRes.path });
  //     // save handle
  //     // if (typeof saveFileHandler === 'function') {
  //     //   const fileItem = await saveFileHandler({
  //     //     ...fileRes,
  //     //     ...itemData,
  //     //     skuId: '',
  //     //   });
  //     //   option.onSuccess(fileItem);
  //     // }
  //     // if (onUploadFileChange && typeof onUploadFileChange === 'function') {
  //     //   onUploadFileChange(fileList);
  //     // }
  //     // dispatch.app.setState({
  //     //   isUploading: false,
  //     // });
  //     setLoading(false);
  //     setUploading(false);
  //   } catch {
  //     setLoading(false);
  //     setUploading(false);
  //   } finally {
  //     dispatch.app.setState({
  //       isUploading: false,
  //     });
  //   }
  // };

  // const handleBeforeUpload = (file: RcFile, choicefileList: RcFile[]) => {
  //   // if (1 + fileList.length > fileMaxLength) {
  //   //   error(t('common.fileMaxLengthMessage'));
  //   //   return Promise.reject();
  //   // }

  //   if (file.name.length > UPLOAD_FILE_NAME_MAX_LENGTH) {
  //     error(
  //       t('common.fileMaxNameMessage', {
  //         length: UPLOAD_FILE_NAME_MAX_LENGTH,
  //       })
  //     );
  //     return Promise.reject();
  //   }

  //   if (!file.size) {
  //     error(t('common.fileEmptyMessage'));
  //     return Promise.reject();
  //   }

  //   return true;
  // };

  useEffect(() => {
    if (loading) {
      dispatch.app.showLoading();
    } else {
      dispatch.app.hideLoading();
    }
  }, [loading, dispatch.app]);

  const updateJobCancellationsHandle = async (
    payload: Partial<JobCancellationParams>
  ) => {
    if (!jobId) return;
    setLoading(true);
    dispatch.app.showLoading();
    try {
      const res = await dispatch.rfm.updateJobCancellations({
        jobId: jobId.toString(),
        id: data.id,
        data: payload,
      });

      setJobCancellations(res);
      setLoading(false);
      dispatch.app.hideLoading();
    } catch (e) {
      console.log(e);
      console.log(data);
      setJobCancellations(data);
      setLoading(false);
      dispatch.app.hideLoading();
    }
  };

  const {
    run: runUpdateJobCancellations,
    cancel: cancelUpdateJobCancellations,
  } = useDebounceFn(
    async (payload: Partial<JobCancellationParams>) => {
      updateJobCancellationsHandle(payload);
    },
    { wait: QUANTITY_DEBOUNCE_MILLISECOND }
  );

  const updateJobCancellations = async (
    payload: Partial<JobCancellationParams>
  ) => {
    cancelUpdateJobCancellations();
    runUpdateJobCancellations(payload);
  };

  const isInternalJob = useMemo(() => {
    return jobData?.jobType === JobTypeEnum.INTERNAL;
  }, [jobData]);

  return (
    <RevxSpin spinning={loading}>
      <div className="jobCancellation">
        <div className="jobCancellation-title">cancel job</div>
        {/* <Form.Item noStyle name="supplierChecked" valuePropName="checked"> */}
        <Checkbox
          checked={data.supplierChecked}
          onChange={(e) => {
            updateJobCancellationsHandle({ supplierChecked: e.target.checked });
          }}
        >
          <div className="jobCancellation-supplierTip">
            Contacted supplier and determined supplier costs associated with the
            cancellation.
            {data.promoterRole === SiteRoleEnum.Buyer &&
              ` Supplier cancellation fees will be communicated
              offline to the buyer.`}
          </div>
        </Checkbox>
        {/* </Form.Item> */}

        <RevxFlexLayout
          justify="justify-start"
          align="center"
          className="jobCancellation-supplier-header"
        >
          <div className="jobCancellation-supplier-header-left">Item</div>
          <div>Total</div>
        </RevxFlexLayout>
        <RevxFlexLayout
          justify="justify-start"
          align="center"
          className="jobCancellation-supplier-body"
        >
          <div className="jobCancellation-supplier-header-left">
            Supplier cancellation fee owed
          </div>
          <div>
            <RevxInputNumber
              prefix="$"
              value={data.cancellationFee}
              onChange={(e) => updateJobCancellations({ cancellationFee: e })}
              precision={2}
            />
          </div>
        </RevxFlexLayout>

        <Checkbox
          checked={data.buyerChecked}
          onChange={(e) =>
            updateJobCancellationsHandle({ buyerChecked: e.target.checked })
          }
        >
          <div className="jobCancellation-supplierTip jobCancellation-sourceTip">
            Contacted Buyer to confirm amount due or refund. Payment or credit
            will be processed in Balance. Remind the customer that they would be
            charged for the job at shipping or pay fees at cancellation.
          </div>
        </Checkbox>

        <div className="jobCancellation-box">
          <RevxFlexLayout className="jobCancellation-source">
            <RevxFlexLayout
              className="jobCancellation-source-label"
              direction="column"
            >
              <div>Items</div>
              <div>Original job cost</div>
              <div>Revised job cost</div>
              <div>Supplier cancellation fee total</div>
              {/* <div>Ready Date</div> */}
              <div hidden={isInternalJob}>Markup</div>
              <div hidden={isInternalJob}>Tax</div>
              <div>New charges</div>
            </RevxFlexLayout>
            <RevxFlexLayout
              className={`jobCancellation-source-item`}
              direction="column"
            >
              <Form.Item>Total</Form.Item>
              {/* Original job cost */}
              <Form.Item>
                <RevxMoney value={data.originalJobCost} />
              </Form.Item>
              {/* Revised job cost */}
              <Form.Item>
                <RevxInputNumber
                  prefix="$"
                  value={data.revisedJobCost}
                  onChange={(e) =>
                    updateJobCancellations({ revisedJobCost: e })
                  }
                  precision={2}
                />
              </Form.Item>
              {/* Supplier cancellation fee total */}
              <Form.Item>
                <RevxMoney value={data.cancellationFee} />
              </Form.Item>
              {/* Markup */}
              <RevxFlexLayout hidden={isInternalJob} justify="space-between">
                <RevxInputNumber
                  suffix="%"
                  value={data.cancellationMarkupPct}
                  disabled={!(data.revisedJobCost + data.cancellationFee)}
                  onChange={(e) =>
                    updateJobCancellations({
                      cancellationMarkupPct: e,
                      cancellationMarkup: +(
                        ((data.revisedJobCost + data.cancellationFee) * e) /
                        100
                      ).toFixed(2),
                    })
                  }
                  precision={2}
                />
                <div className="jobCancellation-source-item-line"></div>
                <RevxInputNumber
                  prefix="$"
                  value={data.cancellationMarkup}
                  disabled={!(data.revisedJobCost + data.cancellationFee)}
                  onChange={(e) =>
                    updateJobCancellations({
                      cancellationMarkupPct: +(
                        (e / (data.revisedJobCost + data.cancellationFee)) *
                        100
                      ).toFixed(2),
                      cancellationMarkup: e,
                    })
                  }
                  precision={2}
                />
              </RevxFlexLayout>
              {/* Tax */}
              <Form.Item hidden={isInternalJob}>
                <RevxMoney value={data.tax} />
              </Form.Item>
              {/* New charges */}
              <Form.Item>
                <RevxMoney value={data.newCharges} />
              </Form.Item>
            </RevxFlexLayout>
          </RevxFlexLayout>

          <RevxFlexLayout
            align="center"
            justify="space-between"
            className="jobCancellation-action"
          >
            {/* <Upload
              maxCount={1}
              multiple={false}
              disabled={loading}
              accept={UPLOAD_ACCEPT}
              fileList={invoiceFileList}
              onRemove={() => {
                setInvoiceFileList([]);
                updateJobCancellationsHandle({ customerInvoiceUrl: '' });
              }}
              customRequest={uploadHandleRequest}
              beforeUpload={handleBeforeUpload}
            >
              {!invoiceFileList.length && (
                <RevxButton brandGreen loading={uploading}>
                  Upload customer invoice
                </RevxButton>
              )}
            </Upload> */}
            <div></div>
            {!readOnly && (
              <RevxFlexLayout align="center" justify="space-between">
                <RevxButton
                  brandBlue
                  onClick={async () => {
                    if (!jobId) return;
                    try {
                      setLoading(true);
                      await dispatch.rfm.cancelJobCancellations({
                        jobId: jobId,
                        id: data.id,
                      });
                      setLoading(false);
                      if (onSuccess) {
                        onSuccess();
                      } else {
                        history.replace(
                          `/workspace/${
                            localStorage.getItem(
                              JOB_ADJUSTMENT_WORKSPACE_FILTER
                            ) || uiStatusFilter
                          }`
                        );
                      }
                    } catch {
                      setLoading(false);
                    }
                  }}
                >
                  Abort
                </RevxButton>

                <Tooltip
                  visible={data.newCharges !== 0 && data.newCharges <= 0.5}
                  title="New charges should be greater than $0.5 to proceed."
                >
                  <RevxButton
                    type="primary"
                    style={{
                      marginLeft: '32px',
                    }}
                    disabled={
                      !data.supplierChecked ||
                      !data.buyerChecked ||
                      (data.newCharges !== 0 && data.newCharges <= 0.5)
                    }
                    onClick={async () => {
                      if (!jobId) return;
                      try {
                        setLoading(true);
                        await dispatch.rfm.submitJobAdjustments({
                          jobId: jobId,
                          id: data.id,
                        });
                        setLoading(false);
                        if (onSuccess) {
                          onSuccess();
                        } else {
                          history.replace(
                            `/workspace/${
                              localStorage.getItem(
                                JOB_ADJUSTMENT_WORKSPACE_FILTER
                              ) || uiStatusFilter
                            }`
                          );
                        }
                      } catch {
                        setLoading(false);
                      }
                    }}
                  >
                    Submit Cancellation
                  </RevxButton>
                </Tooltip>
              </RevxFlexLayout>
            )}
          </RevxFlexLayout>
        </div>
      </div>
    </RevxSpin>
  );
};

export default JobCancellationSource;
